// 10 content hubs — every article must belong to one.
export const HUBS = [
  { slug: "authority-building", name: "Authority Building", accent: "#FF6575" },
  { slug: "personal-branding", name: "Personal Branding", accent: "#5a8aeb" },
  { slug: "content-systems", name: "Content Systems", accent: "#3aab5a" },
  { slug: "seo", name: "SEO Hub", accent: "#ba7a30" },
  { slug: "lead-generation", name: "Lead Generation", accent: "#9a6adb" },
  { slug: "email-marketing", name: "Email Marketing", accent: "#3a9acb" },
  { slug: "digital-products", name: "Digital Products", accent: "#eb5a5a" },
  { slug: "ai-systems", name: "AI Systems", accent: "#bba030" },
  { slug: "authorityos", name: "AuthorityOS", accent: "#FF6575" },
  { slug: "case-studies", name: "Case Studies", accent: "#7a7aeb" },
];

export const HUB_MAP = Object.fromEntries(HUBS.map((h) => [h.slug, h]));

export const CATEGORIES = [
  "Authority Building",
  "Personal Branding",
  "Content Systems",
  "SEO Systems",
  "Lead Generation",
  "Email Marketing",
  "Digital Products",
  "AI & Automation",
  "AuthorityOS Framework",
  "Case Studies",
];
